<template>
  <div>
    <BuscadorTabla v-if="show_buscador" :label="$t('Buscar')" @search_general="filter_tarjetas_regalo"/>
    <!-- Tabla de tarjetas regalo -->
    <v-data-table
        :headers="tabla.headers"
        :items="tabla.tarjetas_regalo"
        :options.sync="tabla.options"
        :server-items-length="tabla.count"
        :fixed-header="true"
        class="elevation-3"
        calculate-widths
        :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
    >
      <template v-slot:item="{ item }">
        <tr :class="{
          'red--text': !item.is_active || item.is_consumida, 'pointer': true,  'selected': current_selected && current_selected.id === item.id
        }"
            @click="item_selected(item)" >
          <td>{{ item.numeracion }}</td>
          <td v-if="!is_venta">{{ item.created | moment('DD/MM/YYYY HH:mm') }}</td>
          <td>{{ item.importe }} {{ $store.state.centro.centro.divisa.simbolo }}</td>
          <td>{{ item.fecha_caducidad | moment('DD/MM/YYYY') }}</td>
          <td v-if="!is_venta">{{ item.fecha_venta | moment('DD/MM/YYYY HH:mm') }}</td>
          <td v-if="!is_venta">{{ item.cliente_comprador }}</td>
          <td v-if="!is_venta">{{ item.saldo_restante }} {{ $store.state.centro.centro.divisa.simbolo }}</td>
          <td v-if="!is_venta">{{ item.is_consumida ? $t('Si') : $t('No') }}</td>
          <td v-if="!is_venta">{{ item.is_vendida ? $t("Si") : $t("No") }}</td>
          <td>
            <v-tooltip v-if="item.notas" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-note-outline
                </v-icon>
              </template>
              <span>{{ item.notas }}</span>
            </v-tooltip>
          </td>

          <td v-if="is_editable">
            <div class="text-center">
              <v-menu bottom offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" small color="primary">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item class="pointer" @click="print_ticket(item.id)">
                    <v-list-item-title>{{ $t("Imprimir tarjeta") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!item.is_vendida" class="pointer" @click="$emit('on_click_edit', item)">
                    <v-list-item-title>{{ $t("Editar tarjeta") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!item.is_active" class="pointer" @click="$emit('on_click_reactivate', item)">
                    <v-list-item-title>{{ $t("Reactivar tarjeta") }}</v-list-item-title>
                  </v-list-item>
                  <v-divider v-if="!item.is_vendida"/>
                  <v-list-item @click="$emit('on_click_delete', item)" v-if="!item.is_vendida">
                    <v-list-item-title class="pointer red--text">{{ $t('Eliminar tarjeta') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </td>

        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'TablaTarjetasRegalo',
  props: {
    // Filtros para realizar la búsqueda
    selected_filters: {
      type: Object,
      default: {},
      required: true
    },
    show_buscador: {
      type: Boolean,
      default: false
    },
    is_venta: {
      type: Boolean,
      default: true
    },
    allow_editar: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    tabla: {
      tarjetas_regalo: [],
      count: 0,
      headers: [],
      filtros: {
        search: null
      },
      options: {
        itemsPerPage: localStorage.getItem('itemsPerPage') ? parseInt(localStorage.getItem('itemsPerPage')) :  10
      }
    },
    current_selected: null
  }),

  methods: {
    /**
     * Recupera las tarjetas regalo de la api
     */
    async get_tarjetas_regalo() {
      // Preparamos los filtros del buscador
      if (this.tabla.filtros['nombre'])
        this.tabla.filtros['search'] = this.tabla.filtros['nombre']

      let filtros = { ...this.tabla.filtros, ...this.selected_filters }

      const response = await this.$store.dispatch("tarjeta_regalo/get_tarjetas_regalo", {
        params: filtros
      });

      this.tabla.tarjetas_regalo = response.results;
      this.tabla.count = response.count;
    },

    item_selected(tarjeta){
      this.current_selected = tarjeta
      this.$emit('on_click_selected', tarjeta)
    },

    filter_tarjetas_regalo(filter) {
      this.tabla.filtros['search'] = filter
      this.tabla.filtros['offset'] = 0
      this.tabla.options.page = 1
      this.get_tarjetas_regalo();
    },

    print_ticket(id){
      const routeData = this.$router.resolve({name: 'print_tarjeta_regalo', params: {id: id}})
      window.open(routeData.href, '_blank');
    }
  },

  mounted() {
    if (this.is_venta){
      this.tabla.headers = [
        { text: this.$t("Numeración"), value: "numeracion", class: "primary white--text"},
        { text: this.$t("Importe"), value: "importe", class: "primary white--text" },
        { text: this.$t("Fecha caducidad"), value: "fecha_caducidad", class: "primary white--text" },
      ]
    } else {
      this.tabla.headers = [
        { text: this.$t("Numeración"), value: "numeracion", class: "primary white--text"},
        { text: this.$t("Fecha creación"), value: "created", class: "primary white--text" },
        { text: this.$t("Importe"), value: "importe", class: "primary white--text" },
        { text: this.$t("Fecha caducidad"), value: "fecha_caducidad", class: "primary white--text" },
        { text: this.$t("Fecha venta"), value: "fecha_venta", class: "primary white--text" },
        { text: this.$t("Cliente comprador"), value: "cliente_comprador", class: "primary white--text" },
        { text: this.$t("Saldo restante"), value: "saldo_restante", class: "primary white--text" },
        { text: this.$t("Consumida"), value: "is_consumida", class: "primary white--text" },
        { text: this.$t("Vendida"), value: "is_vendida", class: "primary white--text" }
      ]
    }

    this.tabla.headers.push(
      { text: this.$t("Notas"), value: "notas", class: "primary white--text" },
      { text: "", value: "actions", class: "primary white--text", sortable: false, align: "right", width: "10px" }
    )

    // Si no es editable (caso venta) eliminamos la columna de acciones
    if(!this.is_editable) this.tabla.headers.pop()
  },

  computed: {
    is_editable(){
      return !this.is_venta && this.allow_editar
    }
  },

  watch: {
    'tabla.options': {
      handler(value, oldValue){
        if(value.itemsPerPage !== oldValue.itemsPerPage){
          try{
            localStorage.setItem('itemsPerPage', value.itemsPerPage)
          }catch (e){}
        }
        this.tabla.filtros['limit'] = value.itemsPerPage
        this.tabla.filtros['offset'] = ((value.page - 1) * value.itemsPerPage)
        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.tabla.filtros['ordering'] = `${desc}${value.sortBy[0]
              .split(".")
              .join("__")}`;
        }
        this.get_tarjetas_regalo()
      },
    },
  },

  components: {
    BuscadorTabla: () => import('@/components/core/BuscadorTabla.vue')
  }
}
</script>

<style lang="scss" scoped>
.selected{
  background-color: grey !important;
  color: white !important;

  &:hover{
    background-color: grey !important;
    color: white !important;
  }

  td {
    background-color: grey !important;
    color: white !important;

    &:hover{
      background-color: grey !important;
      color: white !important;
    }
  }

}
</style>
